import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import App from './views/App'
import store from '@store'
import rootSaga from '@saga'
import '@assets/less/common/index'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import { init } from '@utils/sentry'
import './assets/css'

store.runSaga(rootSaga)

if (process.env.NODE_ENV === 'production') {
  init()
}

function renderDom() {
  render(
    <Provider store={store}>
      <ConfigProvider locale={zhCN}>
        <App />
      </ConfigProvider>
    </Provider>,
    document.getElementById('app')
  )
}
renderDom()
